import React from 'react'
// import { Link } from 'react-router-dom';


const Blog3 = () => {

    return (
        <>
        <section className="main-wrapper bg-grey">
          <div className="container">
            <div className="main-content mt-20 ov-hidden">
              <div className="col-md-8 sm-padding">
                <div className="blog-details padding-25 bg-white bd-grey mb-30">
                  <h2 className="mb-5 fw-6">
                    तेजस्वी यादव ने अपने माता-पिता के क्रियाकलापों के लिए कभी अफसोस
                    जाहिर नहीं किया: अशोक चैधरी
                  </h2>
                  <img
                    src="img/Politics/ashok-chodhary.jpeg"
                    alt="ashok-chodhary"
                    className="img-w1"
                  />
                  <div className="meta-info mb-25 mt-5">
                    <span className="mt-5">
                      <i className="ti-calendar fz-18" />{" "}
                      <a >31 Augest, 2024</a>
                    </span>
                  </div>
                  {/* blog-details */}
                  <p>
                    तेजस्वी यादव ने अपने माता-पिता के क्रियाकलापों के लिए कभी अफसोस
                    जाहिर नहीं किया: अशोक चैधरी
                  </p>
                  <p>
                    शुक्रवार को जनता दल (यू0) प्रदेश कार्यालय, पटना में बिहार सरकार के
                    माननीय ग्रामीण कार्य मंत्री श्री अशोक चैधरी ने प्रदेश के विभिन्न
                    जिलों से पहुंचे आमजनों की समस्याओं को सुनकर उनके त्वरित समाधान
                    हेतु संबंधित अधिकारियों को आवश्यक दिशा-निर्देश दिए। मौके पर माननीय
                    विधानपार्षद श्री संजय कुमार सिंह उर्फ ‘गांधी जी’ एवं जिलाध्यक्ष
                    श्री रूदल राय मौजूद रहे।
                  </p>
                  <p>
                    इस दौरान माननीय मंत्री श्री अशोक चैधरी ने पत्रकारों से बातचीत करते
                    हुए कहा कि राजद के 15 वर्षों के शासन में प्रदेश की क्या स्थिति थी
                    और अधिकारियों के साथ किस तरह का बर्ताव किया जाता था, यह जगजाहिर
                    है। नेता प्रतिपक्ष श्री तेजस्वी यादव ने अपने माता-पिता के
                    क्रियाकलापों को लेकर काफी अफसोस या खेद व्यक्त नहीं किया। नीतीश
                    सरकार पर सवाल खड़े करने से पहले उन्हें अपने गिरेबान में जरूर झांकना
                    चाहिए। श्री अशोक चैधरी ने कहा कि नेता प्रतिपक्ष एक गरिमापूर्ण पद
                    होता है, राह चलते बेगैर तथ्यों के सरकार पर कुछ भी आरोप लगाना कहीं
                    से भी शोभनीय नहीं है। श्री तेजस्वी यादव को आरोपों के साथ-साथ
                    प्रमाणिक आधार भी जनता के समक्ष रखना चाहिए।
                  </p>
                  <p>
                    आगे उन्होंने कहा कि जातीय गणना कराने में राजद की कोई भूमिका नहीं
                    है, झूठा प्रचार करने से उन्हें कुछ भी हासिल नहीं होगा। माननीय
                    मुख्यमंत्री श्री नीतीश कुमार ने जब बिहार में जातीय गणना का नीतिगत
                    निर्णय लिया तो उस वक्त राजद नीतीश सरकार में भागीदार नहीं था। तमाम
                    अड़चनों के बावजूद भी जातीय गणना का काम पूरा होना और ससमय उसके आँकड़े
                    जारी करना माननीय मुख्यमंत्री श्री नीतीश कुमार के राजनीतिक कूटनीति
                    का नतीजा है
                  </p>
                  {/* ***************************** content end********************************************************************** */}
                  <ul className="single-tags">
                    <li>Tags</li>
                    <li>
                      <a >Sports</a>
                    </li>
                    <li>
                      <a >Travel</a>
                    </li>
                  </ul>
                  <div className="social-share-wrap">
                    <span className="fz-16 text-black fw-6">Share This Article</span>
                    <ul className="share-icon">
                      <li>
                        <a >
                          <i className="ti-facebook" /> Facebook
                        </a>
                      </li>
                      <li>
                        <a >
                          <i className="ti-twitter" /> Twitter
                        </a>
                      </li>
                      <li>
                        <a >
                          <i className="ti-google" /> Google+
                        </a>
                      </li>
                    </ul>
                  </div>
                  {/* social-share-wrap */}
                </div>
                {/* /.blog-details */}
              </div>
              {/* content block */}
              <aside className="col-md-4 sm-padding">
                <div className="sidebar-wrap">
                  <div className="single-sidebar no-padding">
                    <a
                      href="https://www.accuweather.com/en/us/new-york-ny/10007/weather-forecast/349727"
                      className="aw-widget-legal"
                    >
                      {/*
                                By accessing and/or using this code snippet, you agree to AccuWeather’s terms and conditions (in English) which can be found at https://www.accuweather.com/en/free-weather-widgets/terms and AccuWeather’s Privacy Statement (in English) which can be found at https://www.accuweather.com/en/privacy.
                                */}
                    </a>
                    <div
                      id="awcc1499974479079"
                      className="aw-widget-current"
                      data-locationkey=""
                      data-unit="c"
                      data-language="en-us"
                      data-useip="true"
                      data-uid="awcc1499974479079"
                    />
                  </div>
                  {/* /.single-sidebar */}
                  <div className="single-sidebar no-padding">
                    <div className="side-tab">
                      <ul className="tab-menu mb-15">
                        <li className="active">
                          <a href="#recent" data-toggle="tab">
                            Recent
                          </a>
                        </li>
                        <li>
                          <a href="#popular" data-toggle="tab">
                            Popular
                          </a>
                        </li>
                        <li>
                          <a href="#comments" data-toggle="tab">
                            Comments
                          </a>
                        </li>
                      </ul>
                      <div className="tab-content bd-grey padding-15">
                        <div className="tab-pane fade in active" id="recent">
                          <ul className="list-post-items">
                            <li>
                              <img src="img/tab-1.jpg" alt="Image" />
                              <div className="list-post-content bd-grey">
                                <h4 className="fz-14">
                                  <a >William Braynt went to visit the US.</a>
                                </h4>
                                <p className="fz-12 fw-6 tt-u no-margin">
                                  national Octobar 2023
                                </p>
                              </div>
                            </li>
                            <li>
                              <img src="img/tab-2.jpg" alt="Image" />
                              <div className="list-post-content bd-grey">
                                <h4 className="fz-14">
                                  <a >
                                    Style icon angelina goes to take oscar.
                                  </a>
                                </h4>
                                <p className="fz-12 fw-6 tt-u no-margin">
                                  national Octobar 2023
                                </p>
                              </div>
                            </li>
                            <li>
                              <img src="img/tab-3.jpg" alt="Image" />
                              <div className="list-post-content bd-grey">
                                <h4 className="fz-14">
                                  <a >
                                    How to become a wildlife photographer?
                                  </a>
                                </h4>
                                <p className="fz-12 fw-6 tt-u no-margin">
                                  national Octobar 2023
                                </p>
                              </div>
                            </li>
                            <li>
                              <img src="img/tab-4.jpg" alt="Image" />
                              <div className="list-post-content bd-grey">
                                <h4 className="fz-14">
                                  <a >
                                    linin park singer is no more. he is top in the
                                    world.
                                  </a>
                                </h4>
                                <p className="fz-12 fw-6 tt-u no-margin">
                                  national Octobar 2023
                                </p>
                              </div>
                            </li>
                          </ul>
                        </div>{" "}
                        {/* /#recent */}
                        <div className="tab-pane fade in" id="popular">
                          <ul className="list-post-items">
                            <li>
                              <img src="img/tab-1.jpg" alt="Image" />
                              <div className="list-post-content bd-grey">
                                <h4 className="fz-14">
                                  <a >
                                    William Braynt went to visit the grabl
                                  </a>
                                </h4>
                                <p className="fz-12 fw-6 tt-u no-margin">
                                  national Octobar 2023
                                </p>
                              </div>
                            </li>
                            <li>
                              <img src="img/tab-2.jpg" alt="Image" />
                              <div className="list-post-content bd-grey">
                                <h4 className="fz-14">
                                  <a >
                                    William Braynt went to visit the grabl
                                  </a>
                                </h4>
                                <p className="fz-12 fw-6 tt-u no-margin">
                                  national Octobar 2023
                                </p>
                              </div>
                            </li>
                            <li>
                              <img src="img/tab-3.jpg" alt="Image" />
                              <div className="list-post-content bd-grey">
                                <h4 className="fz-14">
                                  <a >
                                    William Braynt went to visit the grabl
                                  </a>
                                </h4>
                                <p className="fz-12 fw-6 tt-u no-margin">
                                  national Octobar 2023
                                </p>
                              </div>
                            </li>
                            <li>
                              <img src="img/tab-4.jpg" alt="Image" />
                              <div className="list-post-content bd-grey">
                                <h4 className="fz-14">
                                  <a >
                                    William Braynt went to visit the grabl
                                  </a>
                                </h4>
                                <p className="fz-12 fw-6 tt-u no-margin">
                                  national Octobar 2023
                                </p>
                              </div>
                            </li>
                          </ul>
                        </div>{" "}
                        {/* /#popular */}
                        <div className="tab-pane fade in" id="comments">
                          <ul className="list-post-items">
                            <li>
                              <img src="img/tab-1.jpg" alt="Image" />
                              <div className="list-post-content bd-grey">
                                <h4 className="fz-14">
                                  <a >
                                    William Braynt went to visit the grabl
                                  </a>
                                </h4>
                                <p className="fz-12 fw-6 tt-u no-margin">
                                  national Octobar 2023
                                </p>
                              </div>
                            </li>
                            <li>
                              <img src="img/tab-2.jpg" alt="Image" />
                              <div className="list-post-content bd-grey">
                                <h4 className="fz-14">
                                  <a >
                                    William Braynt went to visit the grabl
                                  </a>
                                </h4>
                                <p className="fz-12 fw-6 tt-u no-margin">
                                  national Octobar 2023
                                </p>
                              </div>
                            </li>
                            <li>
                              <img src="img/tab-3.jpg" alt="Image" />
                              <div className="list-post-content bd-grey">
                                <h4 className="fz-14">
                                  <a >
                                    William Braynt went to visit the grabl
                                  </a>
                                </h4>
                                <p className="fz-12 fw-6 tt-u no-margin">
                                  national Octobar 2023
                                </p>
                              </div>
                            </li>
                            <li>
                              <img src="img/tab-4.jpg" alt="Image" />
                              <div className="list-post-content bd-grey">
                                <h4 className="fz-14">
                                  <a >
                                    William Braynt went to visit the grabl
                                  </a>
                                </h4>
                                <p className="fz-12 fw-6 tt-u no-margin">
                                  national Octobar 2023
                                </p>
                              </div>
                            </li>
                          </ul>
                        </div>{" "}
                        {/* /#comments */}
                      </div>
                    </div>
                  </div>
                  {/* /.single-sidebar */}
                  <div className="single-sidebar">
                    <h3 className="fw-8 fz-18 tt-u mb-30">Subscribe News24</h3>
                    <form action="#" className="subscribe-form">
                      <input
                        type="email"
                        name="email"
                        placeholder="Enter Your Email"
                      />
                      <input type="submit" defaultValue="Subscribe" />
                    </form>
                  </div>
                  {/* /.single-sidebar */}
                  <div className="single-sidebar">
                    <div id="calendar_wrap" className="calendar_wrap">
                      <table id="wp-calendar">
                        <caption>Agust 2024</caption>
                        <thead>
                          <tr>
                            <th scope="col" title="Monday">
                              M
                            </th>
                            <th scope="col" title="Tuesday">
                              T
                            </th>
                            <th scope="col" title="Wednesday">
                              W
                            </th>
                            <th scope="col" title="Thursday">
                              T
                            </th>
                            <th scope="col" title="Friday">
                              F
                            </th>
                            <th scope="col" title="Saturday">
                              S
                            </th>
                            <th scope="col" title="Sunday">
                              S
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td colSpan={3} id="prev" className="pad">
                              &nbsp;
                            </td>
                            <td className="pad">&nbsp;</td>
                            <td colSpan={3} id="next" className="pad">
                              &nbsp;
                            </td>
                          </tr>
                        </tbody>
                        <tbody>
                          <tr>
                            <td colSpan={5} className="pad">
                              &nbsp;
                            </td>
                            <td>1</td>
                            <td>2</td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>4</td>
                            <td>5</td>
                            <td>6</td>
                            <td>7</td>
                            <td>
                              <a
                                href="http://cracktheme.com/codehube/2024/07/08/"
                                aria-label="Posts published on July 8, 2023"
                              >
                                8
                              </a>
                            </td>
                            <td>9</td>
                          </tr>
                          <tr>
                            <td>10</td>
                            <td>11</td>
                            <td>
                              <a
                                href="http://cracktheme.com/codehube/2024/07/12/"
                                aria-label="Posts published on July 12, 2023"
                              >
                                12
                              </a>
                            </td>
                            <td>
                              <a
                                href="http://cracktheme.com/codehube/2024/07/13/"
                                aria-label="Posts published on July 13, 2023"
                              >
                                13
                              </a>
                            </td>
                            <td>14</td>
                            <td>15</td>
                            <td>16</td>
                          </tr>
                          <tr>
                            <td>17</td>
                            <td>18</td>
                            <td>19</td>
                            <td id="today">20</td>
                            <td>21</td>
                            <td>22</td>
                            <td>23</td>
                          </tr>
                          <tr>
                            <td>24</td>
                            <td>25</td>
                            <td>26</td>
                            <td>27</td>
                            <td>28</td>
                            <td>29</td>
                            <td>30</td>
                          </tr>
                          <tr>
                            <td>31</td>
                            <td className="pad" colSpan={6}>
                              &nbsp;
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.single-sidebar */}
                </div>
                {/* /.sidebar-wrap */}
              </aside>
              {/* sidebar block */}
            </div>
            {/* /.main-content */}
          </div>
          {/* /.container */}
        </section>
        {/* /.main-wrapper */}
      </>
      
    )
}

export default Blog3;